import { connect } from 'react-redux';
import { signup, loadJobs, login } from '../../reducers/auth.reducers';
import { errorNotification } from '../../reducers/notification.reducers';
import Login from './login';

const mapDispatchToProps = dispatch => ({
  signup: form => dispatch(signup(form)),
  loadJobs: () => dispatch(loadJobs()),
  showValidationError: error => dispatch(errorNotification(error)),
  login: credentials => dispatch(login(credentials)),
});

const mapStateToProps = state => ({
  loggedIn: state.authentication.loggedIn,
  userName: state.authentication.userName,
  errorMessage: state.authentication.errorMessage,
  loading: state.authentication.loading,
  jobs: state.authentication.jobs,
  config: state.authentication.config,
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/app/platform-startscreen/login/login.container.js